/** @jsx jsx */
import React, { useContext, useState } from 'react';
import { Button, Dialog, Classes, Intent, InputGroup, Spinner } from '@blueprintjs/core';
import { jsx, css } from '@emotion/react';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import { get, post, RESULT_END_POINTS } from 'srs-middleware';

// Reference: https://flaviocopes.com/javascript-sleep/
const sleep = (milliseconds) => {
	return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

/**
 * Component responsible for causing the current active explorer to be exported.
 *
 * @returns {*}
 * @constructor
 */
export const Export = ({ ...props }) => {
	const {
		state: {
			transient: { activeResult },
		},
	} = useContext(WorkspaceContext);
	const [fileName, setFileName] = useState('');
	const [showDialog, setShowDialog] = useState(false);
	const [exportingStatus, setExportingStatus] = useState(false);

	const exportResult = async () => {
		setFileName('');
		setExportingStatus(true);

		let export_result = await post(RESULT_END_POINTS.Export(activeResult.resultId), {
			pluginId: '53738BFE-25A3-4ec2-996C-9AD36903DA75',
			exportName: fileName || 'serberus-export',
		});

		while (!export_result.isAvailable) {
			await sleep(1000);
			export_result = await get(`/SRS/Export/${export_result.exportId}/Status`, {});
		}

		// Open the download link in a new tab.
		window.open(export_result.url, '_blank');
		setExportingStatus(false);
		setShowDialog(false);
	};

	const handleCancel = () => {
		setShowDialog(false);
		setFileName('');
		setExportingStatus(false);
	};

	return (
		<React.Fragment>
			<Button
				rightIcon={'export'}
				onClick={() => setShowDialog(true)}
				children={'Export'}
				// css={alignedMinimalButtonRight}
				minimal
				cy-test="export-button"
				{...props}
			/>
			<Dialog title={'Export Result'} icon={'export'} isOpen={showDialog} onClose={handleCancel}>
				<div css={container}>
					{!exportingStatus ? (
						<React.Fragment>
							<div>
								This will export a CSV with a total of <strong>{activeResult?.count}</strong> rows.
							</div>
							<InputGroup
								intent={Intent.PRIMARY}
								placeholder={'Please enter a file name...'}
								autoFocus
								fill
								large
								value={fileName}
								onKeyPress={(e) => (e.key === 'Enter' ? exportResult() : null)}
								onChange={(e) => setFileName(e.target.value)}
								leftIcon={'export'}
								cy-test="export-textbox"
							/>
							<div className={Classes.DIALOG_FOOTER}>
								<div className={Classes.DIALOG_FOOTER_ACTIONS}>
									<Button intent={Intent.PRIMARY} onClick={exportResult} cy-test="export-save-button">
										Save
									</Button>
									<Button intent={Intent.NONE} onClick={handleCancel} cy-test="export-cancel-button">
										Cancel
									</Button>
								</div>
							</div>
						</React.Fragment>
					) : (
						<Spinner />
					)}
				</div>
			</Dialog>
		</React.Fragment>
	);
};

const container = css`
	display: grid;
	grid-template-columns: 1fr;
	grid-row-gap: 12px;
	padding: 20px;
`;
